import { ThemeImage } from '../ThemeImage';

import styles from './LoadingSpinner.module.scss';
import SpinnerDark from './spinner-dark.svg';
import SpinnerLight from './spinner-light.svg';

type Props = { className?: string; theme?: 'dark' | 'light' };

export function LoadingSpinner({ className, theme }: Props) {
	return (
		<ThemeImage
			srcLight={SpinnerLight}
			srcDark={SpinnerDark}
			className={`${styles.spinner} ${className ?? ''}`}
			alt=""
			data-theme={theme}
		/>
	);
}
